<template>
    <div>
      <h5>
        Q{{item.order}}
      </h5>
      <div class="boardBg surveyBox adminSurbeyBox">
        <div class="surveyBoxTop flex flexAlignS">
          <h4>
            체크박스
          </h4>
          <button @click="$emit('onClickDeleteItem', item.order-1)"></button> <!-- TODO: store로 사용하기 -->
        </div>
  
        <b-form-checkbox class="termCheckBox" v-model="essential">필수항목</b-form-checkbox>

        <div class="surveyBoxInput flex flexAlignS">
          <label for="">질문</label>
          <input v-model="item.question" maxlength="170"/>
        </div>

        <div class="surveyFormOption flex">
          <label>옵션</label>
          <button @click="onClickAddCheck" class="fixedPlusBtn">
            <span>+</span>
          </button>
        </div>
        <div v-for="(listItem, index) in list" :key="index" class="flex flexAlignS surveyBoxInput addInput">
          <input v-model="list[index]" maxlength="341"/> 
          <button @click="onClickDeleteCheck(index)" class="fixedPlusBtn">
            <span>-</span>
          </button>
        </div>
      </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'Check',
  props:{
    item: null,
  },
  data(){
    return{
      list: [] // String List
    }
  },
  computed:{
    essential:{
      get(){
        if(this.item.essential === 'Y') return true
        else return false
      },
      set(value){
        if(value) this.item.essential = 'Y'
        else this.item.essential = 'N'
      }
    }
  },
  beforeMount(){
    this.resetList()
  },
  watch:{
    list:{
      deep: true,
      handler(list){
        this.setOptions({
          item: this.item, 
          list: list
        })
      }
    }
  },
  methods:{
    ...mapMutations('survey', ['setOptions']),
    onClickAddCheck(){
      this.list.push('')
    },
    onClickDeleteCheck(index){
      this.list.splice(index, 1)
    },
    resetList(){
      this.list.length = this.item.options.length
      
      for(var i = 0; i < this.list.length; i++) {
        for(var j = 0; j < this.item.options.length; j++){
          if(this.item.options[j].order == i){
            this.list[i] = this.item.options[j].data
          }
        }
      }

      this.setOptions({
        item: this.item, 
        list: this.list
      })
    }
  }
}
</script>